import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Button } from '../../components/Button';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { apiUser } from '../../api/apiUser.api';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import DotSpinner from '../../components/shared/DotSpinner';
import QRCode from 'react-qr-code';

function ProfileMenu() {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [inviteCode, setInviteCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    apiUser
      .getReferralLink(axiosPrivate)
      .then((res) => setInviteCode(res.data.link))
      .finally(() => setIsLoading(false));
  }, []);

  const handleCopy = () => {
    if (!inviteCode) return;
    navigator.clipboard
      .writeText(inviteCode)
      .then(() => {
        toast.success('Скопировано');
      })
      .catch((err) => {
        toast.error('Ошибка копирования');
        console.error('Ошибка копирования: ', err);
      });
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[100vh]">
        <DotSpinner />
      </div>
    );
  }

  return (
    <>
      <div className="p-4 font-raleway mb-24 space-y-4">
        <div className="rounded-3xl border border-[#233636] bg-[#022424] p-4 flex flex-col items-center">
          <p className="w-full text-center text-[20px] font-semibold mb-[18px] text-white">
            Что вы получаете за каждого приглашёного друга:
          </p>
          <div className="w-full">
            <div className="flex items-center gap-3 text-white">
              <span className="text-[20px] size-[28px] rounded-full bg-[#233636] text-white flex items-center justify-center shrink-0">
                1
              </span>
              <div className="flex items-end gap-1">
                <p className="text-[20px] font-medium">+3</p>{' '}
                <img src="/icons/coin.svg" alt="coin" className="mb-[3px]" />
              </div>
            </div>

            <div className="flex items-center gap-3 text-white">
              <span className="text-[20px] size-[28px] rounded-full bg-[#233636] text-white flex items-center justify-center shrink-0">
                2
              </span>
              <div className="flex items-center gap-1">
                <p className="text-[20px] font-medium">Подарок “Это мэтч”</p>
                <img src="/icons/match-gift.svg" alt="coin" className="" />
              </div>
            </div>
          </div>
        </div>

        <div className="rounded-3xl border border-[#233636] bg-[#022424] p-4 flex flex-col items-center gap-4">
          <p className="w-full text-center text-[20px] font-semibold text-white">Ваша ссылка-приглашение</p>

          <div className="bg-white p-3 rounded-2xl">
            <QRCode value={inviteCode || ''} size={140} />
          </div>

          <p className="text-white/80 text-[13px] text-center break-all select-all">{inviteCode}</p>

          <button
            type="button"
            onClick={handleCopy}
            className="h-[44px] w-full rounded-[400px] border border-[#A1F69E] text-[#A1F69E] font-raleway font-medium text-[16px] active:bg-[#A1F69E]/10"
          >
            Скопировать ссылку
          </button>
        </div>

        <div className="text-black fixed bottom-6 left-4 right-4">
          <Button
            onClick={() => {
              const tg = window.Telegram?.WebApp;

              if (tg && typeof tg.openTelegramLink === 'function') {
                // 2. Формируем ссылку для нативного диалога шаринга
                const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(inviteCode)}&text=${encodeURIComponent('Приглашаю тебя!')}`;

                // 3. Открываем диалог через Telegram
                tg.openTelegramLink(shareUrl);
              } else {
                // 4. Фолбэк для обычных браузеров
                if (navigator.share) {
                  navigator
                    .share({
                      title: 'Пригласить друга',
                      text: 'Приглашаю тебя!',
                      url: inviteCode
                    })
                    .catch((e) => console.error(e));
                } else {
                  toast.error('Ваш браузер не поддерживает данную функцию');
                }
              }
            }}
            className="w-full"
          >
            Отправить приглашение
          </Button>
        </div>
      </div>
    </>
  );
}

export default ProfileMenu;
